import { defineMessages } from 'react-intl';

export default defineMessages({
    makeChanges: {
        id: 'ml.policychange.rentedTrailer.Make Changes',
        defaultMessage: 'Make Changes'
    },
    addRentedTrailerCamper: {
        id: 'ml.policychange.rentedTrailer.Add Trailer Camper',
        defaultMessage: 'Add Rented Trailer/Camper'
    },
    expirationDateInputErrorMessage: {
        id: 'ml.policychange.rentedTrailer.expirationDateInputErrorMessage',
        defaultMessage: 'Rented Trailer/Camper Expiration Date : Change the Expiration Date for Rented Trailer/Camper. Expiration Date should be greater than the Effective date and no more than 90 Days from Effective Date.'
    }
})